import {Component, Input} from '@angular/core';
import * as Moment from "moment";
import {extendMoment} from "moment-range";
const moment = extendMoment(Moment);

@Component({
  selector: 'dev-gantt',
  templateUrl: './gantt.component.html',
  styleUrls: ['./gantt.component.css']
})
export class GanttComponent {
  //todo locale, modularizar, then, arredondar datas de inicio e fim
  configEsc = {};

  @Input() dataInicial: string = "2016-01-01";
  @Input() dataFinal: string = "2020-01-31";
  @Input() escalaTemporal: string = "day";
  @Input() data: any[] = [];
  @Input() lines: any[] = [];
  @Input() lineValue: string;
  @Input() dataInicialField: string;
  @Input() dataFinalField: string;
  @Input() captionField: string;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getPadraoEscala(this.escalaTemporal)
  }

  getPadraoEscala(escTemp) {
      switch (escTemp) {
        case "day":
          this.configEsc = {
            unit: 'day',
            unitSuperior: 'month',
            format: 'DD-MMM',
            formatSuperior: 'MMMM',
            widthUnit: 70
          };
          break;
        case "week":
          this.configEsc = {
            unit: 'week',
            unitSuperior: 'month',
            format: 'Wo',
            formatSuperior: 'MMMM',
            widthUnit: 100,
          };
          break;
      }
  }
}
